import hdapi from "../common/hdapi";
import AsyncLimit from "../common/AsyncLimit";
import {sleep} from "../common/utils";
import {store} from "../plugins";
import {url} from "inspector";

const fs = require("fs");

export const ConverterStates = {
	BROKE_FILE: 0, // 文件损坏
	WAIT: 1, // 待转换
	RUNNING: 2, // 转换中
	SUCCESS: 3, // 转换成功
	FAILURE: 4, // 转换失败
	CANNOT_COMPRESS: 5, // 压缩失败
	LIMIT: 6, // 大小限制
};

export default class Converter {
	constructor() {
		this.files = [];
		this._queue = new AsyncLimit(3);
		this._loadQueue = new AsyncLimit(1);
		this._pushAt = 0;
		this._clearAt = 0;
		this._ysType = "";
		// this.test = [];
	}
	sizeSection(size) {
		let size_section;
		switch (true) {
			case size > 100 * 1024 * 1024:
				size_section = "100M以上";
				break;
			case size > 50 * 1024 * 1024:
				size_section = "50-100M";
				break;
			case size > 20 * 1024 * 1024:
				size_section = "20M-50M";
				break;
			case size > 10 * 1024 * 1024:
				size_section = "10M-20M";
				break;
			case size > 8 * 1024 * 1024:
				size_section = "8M-10M";
				break;
			case size > 5 * 1024 * 1024:
				size_section = "5M-5M";
				break;
			case size > 4 * 1024 * 1024:
				size_section = "4M-5M";
				break;
			case size > 3 * 1024 * 1024:
				size_section = "3M-4M";
				break;
			case size > 2 * 1024 * 1024:
				size_section = "2M-3M";
				break;
			case size > 1 * 1024 * 1024:
				size_section = "1M-2M";
				break;
			case size > 500 * 1024:
				size_section = "500K-1M";
				break;
			case size > 200 * 1024:
				size_section = "200K-500K";
				break;
			default:
				size_section = "0-200K";
		}
		return size_section;
	}
	isRunning(file) {
		return file.state == ConverterStates.RUNNING;
	}
	afterLoad() {
		for (let file of this.files) {
			if (file.state == ConverterStates.RUNNING) {
				file.state = ConverterStates.WAIT;
				file.progress = 0;
			}
		}
	}
	loadFile(path, i) {
		// console.log("path", path);
		i = i || 0;
		var name = hdapi.filename(path);
		var ext = hdapi.extname(path);
		return hdapi
			.stat(path)
			.then((stat) => {
				if (!stat || !stat.size) return Promise.reject(stat);
				return {
					path,
					outpath: "",
					name,
					ext,
					size: stat.size,
					progress: 0,
				};
			})
			.catch((err) => {
				console.log("err", err);
				if (i >= 3) return Promise.reject(err);
				return sleep(1e3).then(() => Converter.prototype.loadFile.call(this, path, i + 1));
			});
	}
	addFiles(files, islimit) {
		console.log("addfile_files", files);
		this._pushAt = Date.now();
		var set = new Set(this.files.map((x) => x.path));
		// console.log("set", set);
		let count = 0;
		for (let x of files) {
			console.log("x", x);
			if (x.constructor == Object) {
				let isAFilePush = true;
				let OriginFilePushPath = x["url"];
				for (let i in x) {
					if (i == "url") continue;
					// x[i] = hdapi.join(x[i], x[0]);
					console.log("x[i]=", x[i]);
					if (set.has(x[i])) continue;
					this._loadQueue.push(() =>
						this.loadFile(x[i], isAFilePush, OriginFilePushPath)
							.then((x) => {
								// console.log("x.size", x.size);
								if (islimit && hdapi.platform == "MAC" && x.size > 50 * 1024 * 1000) {
									count = count + 1;
								}
								this._pushAt > this._clearAt && this.files.push(x);
								if (x.state == ConverterStates.WAIT) {
									gevt(
										"添加文件",
										"任务事件",
										this._ysType,
										"成功",
										store.VIPState,
										this.sizeSection(x.size)
									);
								}
							})
							.catch(() => {
								console.log("添加文件失败");
								gevt(
									"添加文件",
									"任务事件",
									this._ysType,
									"失败",
									store.VIPState,
									this.sizeSection(x.size)
								);
							})
					);
				}
				continue;
			}
			if (set.has(x)) continue;
			this._loadQueue.push(() =>
				this.loadFile(x)
					.then((x) => {
						// console.log("x.size", x.size);
						if (islimit && hdapi.platform == "MAC" && x.size > 50 * 1024 * 1000) {
							count = count + 1;
						}
						this._pushAt > this._clearAt && this.files.push(x);
						if (x.state == ConverterStates.WAIT) {
							gevt(
								"添加文件",
								"任务事件",
								this._ysType,
								"成功",
								store.VIPState,
								this.sizeSection(x.size)
							);
						}
					})
					.catch(() => {
						console.log("添加文件失败");
						gevt(
							"添加文件",
							"任务事件",
							this._ysType,
							"失败",
							store.VIPState,
							this.sizeSection(x.size)
						);
					})
			);
		}
		return this._loadQueue.wait().then(() => {
			return count;
		});
		// return count;
	}
	clear() {
		// console.log("数据已被清除");
		this._clearAt = Date.now();
		for (let x of this.files) {
			if (x.CompressStyle == "online") x.isStopCompress = true;
		}
		this.files = [];
		this._queue.clear();
		this._loadQueue.clear();
		// this.deleteFolderRecursive();
		this.get_PPT_WORD_iniout().then(
			(res) => {
				// console.log("this._iniout", res);
				this.deleteFolderRecursive(res);
			},
			(err) => {}
		);
	}
	deleteFolderRecursive(url) {
		var files = [];
		let _this = this;
		/**
		 * 判断给定的路径是否存在
		 */
		if (fs.existsSync(url)) {
			/**
			 * 返回文件和子目录的数组
			 */
			files = fs.readdirSync(url);
			files.forEach(function (file, index) {
				var curPath = hdapi.join(url, file);
				// console.log("curpath", curPath);
				/**
				 * fs.statSync同步读取文件夹文件，如果是文件夹，在重复触发函数
				 */
				if (fs.statSync(curPath).isDirectory()) {
					// recurse
					_this.deleteFolderRecursive(curPath);
				} else {
					fs.unlinkSync(curPath);
				}
			});
			/**
			 * 清除文件夹
			 */
			fs.rmdirSync(url);
		} else {
			// console.log("给定的路径不存在，请给出正确的路径");
		}
	}
	async get_PPT_WORD_iniout() {
		var main_path = await hdapi.getPath("main");
		main_path = main_path.split("\\");
		main_path.splice(-1, 1);
		main_path = main_path.join("\\");
		// console.log("路径", `${main_path}\\bin\\comressfile\\output`);
		var ini_path = await hdapi
			.exists(`${main_path}\\bin\\compressfile`)
			.then((res) => {
				// console.log("是否有该路径", res);
				if (res) {
					return `${main_path}\\bin\\compressfile\\output`;
				} else {
					return `${main_path}\\resources\\app\\bin\\compressfile\\output`;
				}
			})
			.catch((err) => {
				console.log("查询路径出错", err);
				return err;
			});
		return ini_path;
	}
	remove(file) {
		var idx = this.files.indexOf(file);
		this._queue.remove(file._opt);
		if (idx >= 0) this.files.splice(idx, 1);
		if (file._proc) {
			// console.log("file._proc", file._proc);
			return file._proc.kill().then(() => {
				if (file.state == ConverterStates.RUNNING) hdapi.unlink(file.outpath);
				if (file._outpath && file.state == ConverterStates.RUNNING) {
					// console.log("file._outpath", file._outpath);
					this.deleteFolderRecursive(file._outpath);
				}
			});
		}
		if (file.CompressStyle == "online") {
			file.isStopCompress = true;
		}
	}
	reset() {
		for (let item of this.files) {
			item.state = ConverterStates.WAIT;
		}
	}
	async timewait(url) {}
	async checkOriginDir(x, i) {
		if (i == null) i = 0;
		let _this = this;
		if (x.isAFilePush) {
			let a = x.path.split(x.OriginFilePushPath);
			// a = a[1];
			let b = hdapi.split(a[1]);
			let c;
			b.splice(0, 1);
			let url = hdapi.split(x.OriginFilePushPath).slice(0, -1);
			url.push(store.productName);
			url.push(hdapi.split(x.OriginFilePushPath).slice(-1));
			if (b.length > 1) {
				c = b.slice(0, -1);
				for (let x of c) {
					url.push(x);
				}
			}
			url = hdapi.arrayjoin(url);
			x.outputOriginDir = url;
			let e = await hdapi.exists(url);
			if (!e) {
				return await hdapi
					.mkdirs(url)
					.then((res) => {
						// console.log("文件创建成功", res);
						return "文件创建成功";
					})
					.catch(async (err) => {
						// console.error("文件创建失败", err);
						if (i < 3) {
							i++;
							return await _this.checkOriginDir(x, i);
						}
						return err;
					});
			}
		} else {
			let xjdir;
			xjdir = hdapi.dirname(x.path) + "/" + store.productName;
			let isXjdir = await hdapi.exists(xjdir);
			// console.log("isXjdir-O", isXjdir);
			if (!isXjdir) {
				return await hdapi
					.mkdirs(xjdir)
					.then((res) => {
						// console.log("文件创建成功", res);
						return "文件创建成功";
					})
					.catch((err) => {
						// console.error("文件创建失败", err);
						return err;
					});
			} else return "文件已经存在了";
		}
	}
	async checkCustomDir(x, dir, i) {
		if (i == null) i = 0;
		let _this = this;
		let a = x.path.split(x.OriginFilePushPath);
		// a = a[1];
		let b = hdapi.split(a[1]);
		let c;
		b.splice(0, 1);
		// let url = hdapi.split(dir).slice(0, -1);
		let url = hdapi.split(dir);
		// url.push("迅捷压缩");
		url.push(hdapi.split(x.OriginFilePushPath).slice(-1));
		if (b.length > 1) {
			c = b.slice(0, -1);
			for (let x of c) {
				url.push(x);
			}
		}
		url = hdapi.arrayjoin(url);
		x.outputCustomDir = url;
		let e = await hdapi.exists(url);
		console.log("x.outputCustomDir", x.outputCustomDir, e);
		if (!e) {
			await hdapi
				.mkdirs(url)
				.then((res) => {
					console.log("文件创建成功", url);
					return "文件创建成功";
				})
				.catch(async (err) => {
					console.error("文件创建失败", url, err);
					if (i < 3) {
						i++;
						return await _this.checkCustomDir(x, dir, i);
					}
					return err;
				});
		}
		return;
	}
	run({outputPath, outputOriginDir, limitSize, force, onError}) {
		// debugger;
		// console.log(this);
		// this.test = [];
		gevt("开始压缩", "点击事件", this._ysType, "None", store.VIPState, "None");
		if (!outputOriginDir && !outputPath) return Promise.reject("请先选择输出文件夹");
		var pms = outputOriginDir ? Promise.resolve() : hdapi.mkdirs(outputPath);
		if (this._ysType == "PPT压缩" || this._ysType == "Word压缩" || this._ysType == "PDF压缩") {
			this._isExcededDolgOpen = false;
		}
		return pms.then(() => {
			for (let x of this.files) {
				if (x.state == ConverterStates.RUNNING) continue;
				if (x.state == ConverterStates.BROKE_FILE) continue;
				if (!force && x.state == ConverterStates.CANNOT_COMPRESS) continue;
				if (!force && x.state == ConverterStates.SUCCESS) continue;
				if (!force && x.state == ConverterStates.LIMIT) x.state = ConverterStates.WAIT;
				if (
					force &&
					x.state != ConverterStates.CANNOT_COMPRESS &&
					x.state != ConverterStates.FAILURE
				) {
					x.state = ConverterStates.WAIT;
					if (x.outpath) {
						x.outpath = "";
					}
					if (x.outwidth) {
						x.outwidth = "";
						x.outheight = "";
					}
					if (x.outsize) {
						x.outsize = null;
					}
					// console.log("file", x);
				}
				x.progress = 0;
				x._opt = this._queue.push({
					run: async () => {
						let dirName = hdapi.basename(hdapi.dirname(x.path));
						let outDirName = hdapi.dirname(x.path);
						if (
							(outputOriginDir && dirName != store.productName) ||
							(outputOriginDir && x.isAFilePush)
						) {
							await this.checkOriginDir(x).then((res) => console.log("检查是否有原文件路径", res));
							outDirName = hdapi.join(outDirName, store.productName);
						}
						// debugger;
						var dir = outputOriginDir ? outDirName : outputPath;
						// console.log("dir", dir);
						if (!outputOriginDir && x.isAFilePush) {
							await this.checkCustomDir(x, dir);
						}
						let ys_state = "";
						if (x._pms) return x._pms;
						if (x.size >= limitSize) {
							x.state = ConverterStates.LIMIT;
							onError && onError("SIZE_LIMIT");
							return Promise.reject("SIZE_LIMIT");
						}
						x.state = ConverterStates.RUNNING;
						x.progress = 0;
						x._pms = this.doConvert(x, dir).then(() => this.loadFile(x.outpath));
						x._pms
							.then(
								(out) => {
									console.log("out", out);
									// x.outsize = out.size;
									if (
										out.size >= x.size ||
										window.utils.percent((x.size - out.size) / x.size, 10) <= 0
									) {
										x.state = ConverterStates.CANNOT_COMPRESS;
										// if (x.width == 0) this.test.push(x.ext);
										hdapi.unlink(x.outpath);
										ys_state = "失败";
										if (out.width) {
											x.outwidth = out.width;
											x.outheight = out.height;
										} else {
											x.outwidth = 0;
											x.outheight = 0;
										}
										x.outsize = out.size;
									} else {
										// x.progress = 1;
										// x.progress = 0;
										setTimeout(() => {
											x.state = ConverterStates.SUCCESS;
											ys_state = "成功";
											if (out.width) {
												x.outwidth = out.width;
												x.outheight = out.height;
											} else {
												x.outwidth = 0;
												x.outheight = 0;
											}
											x.outsize = out.size;
											// console.log("ys_state res", ys_state);
										}, 100);
									}
									return ys_state;
								},
								(err) => {
									x.state = ConverterStates.FAILURE;
									console.log("失败", err);
									ys_state = "失败";
									return ys_state;
								}
							)
							.then((res) => {
								// console.log("ys_state res", res);
								if (ys_state == "") {
									let _this = this;
									setTimeout(() => {
										console.log("ys_state res", ys_state);
										if (x.CompressStyle != "online" || !x.CompressStyle) {
											if (
												_this._ysType == "PPT压缩" ||
												_this._ysType == "PDF压缩" ||
												_this._ysType == "Word压缩"
											)
												gevt(
													"执行压缩任务",
													"任务事件",
													_this._ysType,
													ys_state,
													store.VIPState,
													_this.sizeSection(x.size),
													"本地"
												);
											else
												gevt(
													"执行压缩任务",
													"任务事件",
													_this._ysType,
													ys_state,
													store.VIPState,
													_this.sizeSection(x.size)
												);
										} else
											gevt(
												"执行压缩任务",
												"任务事件",
												_this._ysType,
												ys_state,
												store.VIPState,
												_this.sizeSection(x.size),
												"服务端"
											);
									}, 100);
								} else if (x.state != 6) {
									if (x.CompressStyle != "online" || !x.CompressStyle)
										gevt(
											"执行压缩任务",
											"任务事件",
											this._ysType,
											ys_state,
											store.VIPState,
											this.sizeSection(x.size),
											"本地"
										);
									else
										gevt(
											"执行压缩任务",
											"任务事件",
											this._ysType,
											ys_state,
											store.VIPState,
											this.sizeSection(x.size),
											"服务端"
										);
								}
								delete x._pms;
							});
						return x._pms;
					},
					kill: () => {
						if (x._proc) {
							return x._proc.kill().then(() => hdapi.unlink(x.outpath));
						}
					},
				});
			}
			return this._queue.wait();
		});
		// .then(() => {
		// 	console.log(this.test.join(","));
		// });
	}
}
